// Descarga un archivo en base64 (sin el prefijo data:) usando el nombre y tipo dados.
export const descargarBase64 = (base64, nombreArchivo, mimeType = "image/jpeg") => {
  const enlace = document.createElement("a");
  enlace.href = `data:${mimeType};base64,${base64}`;
  enlace.download = nombreArchivo;
  document.body.appendChild(enlace);
  enlace.click();
  document.body.removeChild(enlace);
};

// Descarga un archivo en base64 (sin prefijo data:) convirtiéndolo a Blob.
// Recomendado para archivos grandes (Excel, PDF), donde el data: URL puede fallar.
// Agregado: 2026-09-15 — IA (Claude)
export const MIME_EXCEL = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

export const descargarBase64ComoBlob = (base64, nombreArchivo, mimeType = MIME_EXCEL) => {
  const binario = atob(base64);
  const bytes = new Uint8Array(binario.length);
  for (let i = 0; i < binario.length; i++) bytes[i] = binario.charCodeAt(i);
  const url = URL.createObjectURL(new Blob([bytes], { type: mimeType }));
  const enlace = document.createElement("a");
  enlace.href = url;
  enlace.download = nombreArchivo;
  document.body.appendChild(enlace);
  enlace.click();
  document.body.removeChild(enlace);
  URL.revokeObjectURL(url);
};
